/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2022 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import { getJSEngine } from "selectors/appSelectors";
import * as stores from "stores";

class JSError extends Error {
  constructor(errType, ...params) {
    super(...params);
    this.errCode = errType || 0;
    this.fileName = this.getFileName();
  }

  getFileName() {
    let fileName = "";
    const jsEngine = getJSEngine(stores);
    if (jsEngine) {
      const curEvent = jsEngine.getCurrentEvent();
      fileName = `${curEvent.type}:${curEvent.name}`;
    }
    return fileName;
  }
}

function throwJSError(errType, ...params) {
  throw new JSError(errType, ...params);
}

export default throwJSError;
